module.exports = __webpack_public_path__ + "static/media/lock_icon.da185dda.svg";